import * as React from 'react';
import { useDispatch, useSelector, statusFailed } from '@grandvisionhq/state';
import { unlinkOrder, unlinkOrderFailed } from './actions.js';
import { getUnlinkOrderCall } from '../selectors.js';
import UnlinkView from './UnlinkView.js';

const UnlinkOrderContainer = ({ isSuccessPage , orderNumber ='' , orderToken  })=>{
    const dispatch = useDispatch();
    const unlinkOrderCall = useSelector(getUnlinkOrderCall);
    const viewType = React.useMemo(()=>{
        if (isSuccessPage) {
            return 'success';
        } else {
            return statusFailed(unlinkOrderCall) ? 'failed' : undefined;
        }
    }, [
        isSuccessPage,
        unlinkOrderCall
    ]);
    React.useEffect(()=>{
        if (!isSuccessPage) {
            if (orderToken) {
                dispatch(unlinkOrder({
                    orderToken,
                    orderNumber
                }));
            } else {
                dispatch(unlinkOrderFailed(new Error('Cannot unlink an order without an orderToken')));
            }
        }
    }, [
        dispatch,
        orderNumber,
        isSuccessPage,
        orderToken
    ]);
    return /*#__PURE__*/ React.createElement(UnlinkView, {
        viewType: viewType,
        unlinkedItemId: orderNumber,
        unlinkType: "unlinkOrder"
    });
};
var UnlinkOrderContainer$1 = /*#__PURE__*/ React.memo(UnlinkOrderContainer);

export { UnlinkOrderContainer$1 as default };
//# sourceMappingURL=UnlinkOrderContainer.js.map
